import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';
import { OrderStatus, ServerOrder } from '../../../meta/types/billing/order';
import { ServerOrderPayment } from '../../../meta/types/billing/payment';
import { CONFIG } from '../../../meta/types/config';

const { GET, PUT } = api;

const ORDER_RESOURCE_BASE_PATH = `${CONFIG.dashboardServiceBasePath}/dashboard/v1/purchase/orders`;

type OptionalUserId = { userId?: string };
export interface OrderResource {
  getOrders: ResourceFetch<OrdersResponse, OptionalUserId>;
  getOrder: ResourceFetch<ServerOrder, { orderId: string }>;
  getPayments: ResourceFetch<OrderPaymentResourceResponse, { orderId: string }>;
  getPendingWireTransferOrder: ResourceFetch<ServerOrder, OptionalUserId>;
  getManagementOffer: ResourceFetch<ServerOrder, OptionalUserId>;
  changeStatus: ResourceFetch<ServerOrder, { orderId: string; status: OrderStatus }>;
}

export type OrderPaymentResourceResponse = {
  member: ServerOrderPayment[];
};

export type OrdersResponse = {
  member: ServerOrder[];
};

const OrderResource: OrderResource = {
  getOrders: GET(ORDER_RESOURCE_BASE_PATH),
  getOrder: GET(`${ORDER_RESOURCE_BASE_PATH}/:orderId`),
  getPayments: GET(`${ORDER_RESOURCE_BASE_PATH}/:orderId/payments`),
  getPendingWireTransferOrder: GET(`${ORDER_RESOURCE_BASE_PATH}/pendingWireTransferOrder`),
  changeStatus: PUT(`${ORDER_RESOURCE_BASE_PATH}/:orderId/status/:status`),
  getManagementOffer: GET(`${ORDER_RESOURCE_BASE_PATH}/offer`),
};

export default OrderResource;
